import React from 'react';
import Upper from './Upper.jsx';
import Link from './Link.jsx';
import Lower from './Lower.jsx';
import { useContext } from 'react';
import { alpha, Box, Chip, Stack, Typography, useTheme } from '@mui/material';
import { GameStateContext } from '../../Providers/GameStates/GameState.jsx';

function GameBoard() {
  const theme = useTheme();
  const { state } = useContext(GameStateContext);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        paddingTop: { xs: '92px', sm: '108px' },
        paddingBottom: { xs: '36vh', sm: '34vh' },
        px: 2,
        minHeight: '100vh',
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: '100%', maxWidth: 560, mb: 1.5, px: 0.5 }}
      >
        <Box>
          <Typography
            variant="overline"
            sx={{ color: theme.custom.mutedText, letterSpacing: '0.14em' }}
          >
            Daily word chain game
          </Typography>
          <Typography variant="h6" sx={{ lineHeight: 1.1 }}>
            Build the chain
          </Typography>
        </Box>
        <Chip
          label={`#${state.puzzle_number} · ${state.difficultyLabel}`}
          title={`Estimated difficulty: ${state.difficultyRank} of 5`}
          size="small"
          sx={{
            fontWeight: 800,
            bgcolor: theme.custom.surface,
            border: `1px solid ${theme.custom.border}`,
            backdropFilter: 'blur(14px)',
          }}
        />
      </Stack>
      <Box
        sx={{
          width: '100%',
          maxWidth: 560,
          py: { xs: 2, sm: 2.5 },
          px: { xs: 1, sm: 2.5 },
          borderRadius: '26px',
          bgcolor: theme.custom.surface,
          border: `1px solid ${theme.custom.border}`,
          boxShadow: '0 24px 70px rgba(15, 23, 42, 0.13)',
          backdropFilter: 'blur(20px)',
        }}
      >
        <Upper />
        <Box
          sx={{
            my: 0.75,
            py: 0.55,
            borderRadius: '18px',
            background: `radial-gradient(circle at center, ${alpha(
              theme.custom.aura,
              0.16,
            )}, transparent 68%), linear-gradient(135deg, ${alpha(
              theme.palette.primary.main,
              0.06,
            )}, ${alpha(theme.palette.secondary.main, 0.06)})`,
            border: `1px solid ${alpha(theme.custom.aura, 0.28)}`,
            boxShadow: `inset 0 1px 0 ${alpha(
              theme.palette.common.white,
              0.48,
            )}, 0 0 30px ${alpha(theme.custom.aura, 0.1)}`,
          }}
        >
          <Link />
        </Box>
        <Lower />
      </Box>
    </Box>
  );
}

export default GameBoard;
